;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('sortIcon', SortIconDirective)

  SortIconDirective.$inject = []

  function SortIconDirective () {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<i class="mdi" ng-class="ctrl.reverse ? \'mdi-chevron-up\' : \'mdi-chevron-down\'">',
      bindToController: {
        reverse: '='
      },
      controllerAs: 'ctrl',
      controller: [function () {}]
    }
  }
})(window.angular)
